import { IStore } from 'modules/types';
import { get } from 'lodash';

export const isContactFormSent = (state: IStore) => get(state, 'contact.contact_form_sent');
